import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import {actualizarDatos, actualizarEqOt, getDataList, crearDatos, obtenerGrupoFisicoEquipo, consultarCancelacionDependientesOt } from '../../api/common'
import Spinner from '../commons/Spinner'
import { Modalcarga } from '../Modales/Modalcarga'
import Select from 'react-dropdown-select'
import { Alertassw } from '../Alertas/Alertassw'
import SelectConsult from '../commons/SelectConsult'

export const  Editareq=({infoOt, infoequipo, cambiarestado, refresh, refrescar, origen, setEquiposOtIni})=> {

    
    
    const [modalcharge, SetModalcharge]=useState(true)
    const [sedesClient, SetSedesClient]=useState()
    const [equipo, setEquipoeditar]=useState()

    const[sedeOn, setSedeOn]=useState(true)

    console.log('Info equipo en Editar:', infoequipo)

    const [infoedit, setInfoedit]=useState({
        _id: infoequipo?.equipo? infoequipo?.equipo?._id : infoequipo?._id
    })

    useEffect(() => {
        // Solo asegurar que `_id` esté presente; preservar ediciones en curso
        // (sede, marca, etc.) para no borrarlas por re-render del padre.
        setInfoedit(prev => ({
            ...(prev || {}),
            _id: infoequipo?.equipo ? infoequipo?.equipo?._id : infoequipo?._id
        }))
    }, [infoequipo])

    console.log('Info edit:', infoedit)

    // Modal de confirmación: si corrige el mismo equipo o cambia por otro
    const [showConfirm, setShowConfirm] = useState(false)
    const [pendingSubmit, setPendingSubmit] = useState(false)

    // Modal de equipo existente cuando el serial ya está en uso
    const [showEqExistente, setShowEqExistente] = useState(false)
    const [eqExistente, setEqExistente] = useState(null)
 
    const selectSede = (value)=>{
        if (!value || !value[0]) return;
        const nuevaLabel = value[0].label;
        const nuevoId    = value[0].value;
        if (!nuevoId) return;
        // El <Select> es controlado por `values`: si la sede nueva coincide
        // con la actual (p. ej. el valor inicial que ya se mostraba), evitar
        // disparar setStates que causarían re-renders innecesarios.
        const idActual =
          infoedit?.sedeClient ||
          equipo?.sedeClient?._id ||
          equipo?.sedeClient;
        if (String(idActual) === String(nuevoId)) return;

        // Actualizar la vista sin mutar el objeto directamente — la mutación
        // disparaba React a releer el valor "viejo" en el próximo render.
        setEquipoeditar(prev => prev ? ({
          ...prev,
          sede: nuevaLabel,
          sedeClient: { _id: nuevoId, nameSede: nuevaLabel }
        }) : prev);
        setInfoedit(prev => ({
          ...(prev || {}),
          sede: nuevaLabel,
          sedeClient: nuevoId
        }));
      }

    const handleSubmit=(e)=>{
        e.preventDefault();
        // Siempre mostrar modal de confirmación antes de guardar
        setShowConfirm(true)
    }

    // Ejecutar actualización del mismo equipo (corrección de datos)
    const confirmarCorreccion = async () => {
        setShowConfirm(false)
        SetModalcharge(true)
        try {
            const result = origen === 'historial'
                ? await actualizarDatos('Equipos', infoedit, infoequipo.equipo._id)
                : await actualizarEqOt('Equipos', infoedit, infoequipo._id, infoOt ? infoOt?.numeroOrden : '')

            SetModalcharge(false)
            if (result.status === 200) {
                // Backend retorna EQ_CREATED como status 200 con campo error
                if (result.data?.error === 'EQ_CREATED') {
                    setEqExistente(result.data.equipoExistente)
                    setShowEqExistente(true)
                    return
                }
                const propagados = result.data?.propagados?.length || 0
                const msgPropagados = propagados > 0
                    ? ` Se actualizaron ${propagados} equipo(s) dependiente(s) automáticamente.`
                    : ''
                Alertassw('success', `Cambio registrado correctamente.${msgPropagados}`)
                cambiarestado(false)
                refrescar(!refresh)
            }
        } catch (error) {
            SetModalcharge(false)
            const msg = error?.response?.data?.error?.message
            if (msg === 'EQUIPOS EXISTENTES') {
                Alertassw('error', 'Serial Repetido', 'Hay un equipo creado con el mismo serial, modifica y vuelve a intentarlo')
            } else {
                Alertassw('error', 'Error', 'Ocurrió un error al guardar los cambios')
            }
        }
    }

    // Buscar equipo por serial para sustituir la referencia en la OT
    const confirmarCambioEquipo = async () => {
        setShowConfirm(false)
        const serieIngresada = infoedit.serie || equipo.serie
        if (!serieIngresada) {
            Alertassw('error', 'Sin serial', 'Ingresa el serial del equipo al que deseas cambiar')
            return
        }
        SetModalcharge(true)
        try {
            const clienteId = equipo.cliente?._id || equipo.cliente
            const result = await getDataList('Equipos', { serie: serieIngresada, cliente: clienteId })
            const encontrados = result?.data?.data || []

            if (encontrados.length > 0) {
                SetModalcharge(false)
                setEqExistente(encontrados[0])
                setShowEqExistente(true)
                return
            }

            // No existe: crear equipo nuevo al cliente con los datos del formulario
            // y continuar el flujo de reemplazo automáticamente
            await crearEquipoYReemplazar(serieIngresada, clienteId)
        } catch (error) {
            SetModalcharge(false)
            Alertassw('error', 'Error', 'No se pudo buscar el equipo')
        }
    }

    // ─── Helpers para reemplazo en cascada (spec sincronizacion-cancelacion) ─────

    // Construye snapshot para EquipmentInOt a partir de un equipo físico populado.
    const construirSnapshot = (equipoPopulado, observacionOpt) => ({
        itemId: equipoPopulado.item?._id || equipoPopulado.item,
        item: equipoPopulado.item?.nombre || equipoPopulado.item,
        marca: equipoPopulado.marca,
        modelo: equipoPopulado.modelo,
        serial: equipoPopulado.serie,
        ubicacion: equipoPopulado.ubicacion,
        inventario: equipoPopulado.inventario,
        sede: equipoPopulado.sedeClient?.nameSede || equipoPopulado.sede,
        puntos: equipoPopulado.puntos,
        resolucion: equipoPopulado.resolucion,
        observacion: observacionOpt ?? equipoPopulado.observacion ?? ''
    })

    // Refetch de un equipo por _id (necesario para obtener item.nombre y sedeClient.nameSede).
    const refetchEquipo = async (equipoId) => {
        const res = await getDataList('Equipos', { _id: equipoId })
        return res?.data?.data?.[0] || null
    }

    // Obtiene los EquipmentInOts pareja del equipo original en esta OT.
    // Retorna array de EquipmentInOts (con snapshot y equipo populado).
    // El endpoint responde { parejas: [{ equipoInOtSolicitado, parejaEnOt: [] }] }.
    const obtenerParejaEnOt = async () => {
        try {
            const res = await consultarCancelacionDependientesOt(infoOt._id, [infoequipo._id], [])
            const parejas = res?.data?.parejas || []
            const eqPareja = parejas.flatMap(p => p.parejaEnOt || [])
            console.log('[Editareq.obtenerParejaEnOt] parejas grupos:', parejas.length, 'equipos pareja totales:', eqPareja.length)
            return eqPareja
        } catch (err) {
            console.warn('[Editareq.obtenerParejaEnOt] Falló consulta pareja en OT:', err.message)
            return []
        }
    }

    // Aparea los EquipmentInOts pareja actuales con los equipos físicos nuevos del grupo.
    // Estrategia simple: por índice — el primero de la pareja actual con el primero del grupo
    // nuevo, y así sucesivamente. Si difieren en cantidad, devuelve solo los que hicieron match.
    const aparearParejaConGrupo = (parejaActual, equiposDelGrupoNuevo) => {
        const pares = []
        const len = Math.min(parejaActual.length, equiposDelGrupoNuevo.length)
        for (let i = 0; i < len; i++) {
            pares.push({ eqInOt: parejaActual[i], equipoNuevo: equiposDelGrupoNuevo[i] })
        }
        return { pares, sinMatch: Math.max(parejaActual.length, equiposDelGrupoNuevo.length) - len }
    }

    // Crear equipo nuevo (cuando el serial no existe) y reemplazar la referencia en la OT
    const crearEquipoYReemplazar = async (serieIngresada, clienteId) => {
        const itemId = infoedit.item || equipo.item?._id || equipo.item
        const sedeClientId = infoedit.sedeClient || equipo.sedeClient?._id || equipo.sedeClient
        const marca = infoedit.marca || equipo.marca
        const modelo = infoedit.modelo || equipo.modelo

        if (!itemId || !marca || !modelo || !sedeClientId) {
            SetModalcharge(false)
            Alertassw('error', 'Datos incompletos', 'Faltan ítem, marca, modelo o sede para crear el equipo')
            return
        }

        const payloadEquipo = {
            item: itemId,
            marca,
            modelo,
            serie: serieIngresada,
            inventario: infoedit.inventario ?? equipo.inventario,
            ubicacion: infoedit.ubicacion ?? equipo.ubicacion,
            resolucion: infoedit.resolucion ?? equipo.resolucion,
            puntos: infoedit.puntos ?? equipo.puntos,
            cliente: clienteId,
            sedeClient: sedeClientId
        }

        try {
            // Consulta previa: ¿el equipo original tiene pareja en la OT? Necesitamos saberlo
            // ANTES de crear el nuevo para poder reemplazar en cascada.
            const parejaEnOt = await obtenerParejaEnOt()

            const creado = await crearDatos('Equipos', payloadEquipo)
            const idNuevo = creado?.data?.data?._id
            if (!idNuevo) {
                SetModalcharge(false)
                Alertassw('error', 'Error', 'No se pudo crear el equipo')
                return
            }
            // El backend crea automáticamente dependientes si el item tiene `itemsAdicionales`.
            const dependientesNuevos = creado?.data?.dependientes || []

            const nuevoEquipo = await refetchEquipo(idNuevo)
            if (!nuevoEquipo) {
                SetModalcharge(false)
                Alertassw('error', 'Error', 'No se pudo recuperar el equipo creado')
                return
            }

            // Reemplazo del snapshot del equipo original (padre o miembro del grupo).
            const snapshotData = {
                equipo: nuevoEquipo._id,
                snapshot: construirSnapshot(nuevoEquipo, infoedit.observacion || infoequipo.observacion)
            }
            const result = await actualizarDatos('EqInOt', snapshotData, infoequipo._id)
            if (result.status !== 200) {
                SetModalcharge(false)
                Alertassw('error', 'Error', 'No se pudo reemplazar el equipo original en la OT')
                return
            }

            // Reemplazo en cascada de la pareja en la OT (spec sincronizacion-cancelacion).
            let msgCascada = ''
            if (parejaEnOt.length > 0) {
                if (dependientesNuevos.length === 0) {
                    // El equipo nuevo no tiene dependientes pero el original sí.
                    // Los dependientes originales quedan huérfanos en la OT.
                    SetModalcharge(false)
                    Alertassw('warning', 'Advertencia', `El equipo nuevo no tiene dependientes, pero el equipo original tenía ${parejaEnOt.length} pareja(s) en la OT. Debes revisarlos manualmente.`)
                    cambiarestado(false)
                    refrescar(!refresh)
                    return
                }
                // Refetch de cada dependiente para armar snapshot completo.
                const dependientesPoblados = await Promise.all(
                    dependientesNuevos.map(d => refetchEquipo(d._id))
                )
                const dependientesValidos = dependientesPoblados.filter(Boolean)

                const { pares, sinMatch } = aparearParejaConGrupo(parejaEnOt, dependientesValidos)
                let okCount = 0
                for (const { eqInOt, equipoNuevo } of pares) {
                    try {
                        const parejaSnapshot = {
                            equipo: equipoNuevo._id,
                            snapshot: construirSnapshot(equipoNuevo, eqInOt.snapshot?.observacion)
                        }
                        const r = await actualizarDatos('EqInOt', parejaSnapshot, eqInOt._id)
                        if (r.status === 200) okCount++
                    } catch (err) {
                        console.warn('[Editareq] Falló reemplazo pareja', eqInOt._id, err.message)
                    }
                }
                msgCascada = ` Se reemplazaron ${okCount} pareja(s) en cascada${sinMatch > 0 ? ` (${sinMatch} sin match — revisar manualmente)` : ''}.`
            }

            SetModalcharge(false)
            Alertassw(
                'success',
                'Equipo creado y reemplazado',
                `Se creó "${serieIngresada}" y se reemplazó en la OT.${msgCascada}`
            )
            cambiarestado(false)
            refrescar(!refresh)
        } catch (error) {
            SetModalcharge(false)
            const msg = error?.response?.data?.error?.message
            if (msg === 'EQUIPOS EXISTENTES') {
                Alertassw('error', 'Serial repetido', 'Ya existe un equipo con ese serial. Revisa e intenta de nuevo.')
            } else {
                Alertassw('error', 'Error', 'No se pudo crear o reemplazar el equipo')
            }
        }
    }

    // Usar el equipo encontrado para reemplazar la referencia en EquipmentInOts.
    // Si el equipo original tenía pareja en la OT (padre-hijos), se reemplaza en
    // cascada usando el grupo físico del equipo existente.
    // Spec: sincronizacion-cancelacion.
    const usarEquipoExistente = async () => {
        console.log('%c[Editareq.usarEquipoExistente v2 CASCADA] START', 'color: cyan; font-weight: bold', 'eqExistente:', eqExistente?._id, 'infoOt._id:', infoOt?._id, 'infoequipo._id:', infoequipo?._id)
        if (!eqExistente) return

        // Validar que el equipo encontrado no esté ya en la OT
        const equiposEnOt = infoOt?.equipos || []
        const yaEstaEnOt = equiposEnOt.some(eq => {
            const eqId = eq?.equipo?._id?.toString() || eq?.equipo?.toString()
            return eqId === eqExistente._id?.toString()
        })

        if (yaEstaEnOt) {
            Alertassw('error', 'Equipo ya en OT', 'Este equipo ya se encuentra registrado en la orden de trabajo')
            return
        }

        SetModalcharge(true)
        setShowEqExistente(false)
        try {
            // Consultar pareja del equipo original en la OT + grupo físico del equipo nuevo.
            console.log('[Editareq.usarEquipoExistente] consultando pareja + grupo físico...')
            const [parejaEnOt, grupoRes] = await Promise.all([
                obtenerParejaEnOt(),
                obtenerGrupoFisicoEquipo(eqExistente._id)
            ])
            console.log('[Editareq.usarEquipoExistente] parejaEnOt:', parejaEnOt.length, 'grupoRes:', grupoRes?.data)
            const grupoNuevo = grupoRes?.data || {}
            const padreNuevo = grupoNuevo.padre
            const hijosNuevos = grupoNuevo.hijos || []

            // Determinar cuál equipo del grupo nuevo corresponde al "original" (padre o hijo).
            const originalEsPadre = !eqExistente.equipoDependiente
            const nuevoParaOriginal = eqExistente // el que el usuario eligió reemplaza el original
            // "Otros del grupo nuevo" = padre + hijos, excluyendo al que ya reemplaza al original.
            const otrosDelGrupoNuevo = [padreNuevo, ...hijosNuevos]
                .filter(Boolean)
                .filter(e => String(e._id) !== String(nuevoParaOriginal._id))

            // 1. Reemplazar snapshot del equipo original.
            const nuevoPoblado = await refetchEquipo(nuevoParaOriginal._id)
            if (!nuevoPoblado) {
                SetModalcharge(false)
                Alertassw('error', 'Error', 'No se pudo recuperar el equipo elegido')
                return
            }
            const snapshotData = {
                equipo: nuevoPoblado._id,
                snapshot: construirSnapshot(nuevoPoblado, infoedit.observacion || infoequipo.observacion)
            }
            const result = await actualizarDatos('EqInOt', snapshotData, infoequipo._id)
            if (result.status !== 200) {
                SetModalcharge(false)
                Alertassw('error', 'Error', 'No se pudo reemplazar el equipo')
                return
            }

            // 2. Reemplazo en cascada de pareja en la OT.
            let msgCascada = ''
            if (parejaEnOt.length > 0) {
                if (otrosDelGrupoNuevo.length === 0) {
                    SetModalcharge(false)
                    Alertassw('warning', 'Advertencia', `El equipo elegido no tiene pareja registrada, pero el equipo original tenía ${parejaEnOt.length} pareja(s) en la OT. Revisa los equipos huérfanos manualmente.`)
                    cambiarestado(false)
                    refrescar(!refresh)
                    return
                }
                // Refetch de los otros del grupo nuevo (para snapshots completos).
                const otrosPoblados = await Promise.all(otrosDelGrupoNuevo.map(e => refetchEquipo(e._id)))
                const otrosValidos = otrosPoblados.filter(Boolean)

                const { pares, sinMatch } = aparearParejaConGrupo(parejaEnOt, otrosValidos)
                let okCount = 0
                for (const { eqInOt, equipoNuevo } of pares) {
                    try {
                        const parejaSnapshot = {
                            equipo: equipoNuevo._id,
                            snapshot: construirSnapshot(equipoNuevo, eqInOt.snapshot?.observacion)
                        }
                        const r = await actualizarDatos('EqInOt', parejaSnapshot, eqInOt._id)
                        if (r.status === 200) okCount++
                    } catch (err) {
                        console.warn('[Editareq] Falló reemplazo pareja', eqInOt._id, err.message)
                    }
                }
                msgCascada = ` Se reemplazaron ${okCount} pareja(s) en cascada${sinMatch > 0 ? ` (${sinMatch} sin match)` : ''}.`
            }

            SetModalcharge(false)
            Alertassw('success', 'Equipo reemplazado correctamente', msgCascada.trim())
            cambiarestado(false)
            refrescar(!refresh)
        } catch (error) {
            SetModalcharge(false)
            console.error('[Editareq] Error en usarEquipoExistente:', error)
            Alertassw('error', 'Error', 'No se pudo reemplazar el equipo')
        }
    }

   const CAMPOS_VACIABLES = ['serie', 'observacion'];

   const handledata=(event)=>{
    if(event.target.value || CAMPOS_VACIABLES.includes(event.target.name)){
        setInfoedit({
            ...infoedit,
            [event.target.name]:event.target.value
        })
    }else{
        const { [event.target.name]: _, ...newInfoedit } = infoedit;
        setInfoedit(newInfoedit);
    }
   }

   // Antes dependía de `sedeOn`, lo que hacía que al abrir/cerrar el selector
   // de sede se recargara el equipo original y se reseteara `infoedit`,
   // perdiendo la nueva sede antes de guardar. Ahora solo se dispara cuando
   // cambia realmente el equipo que se está editando.
   useEffect(()=>{

    async function  consultarOt(){
        const equipoRefId = infoequipo?.equipo?._id || infoequipo?.equipo
        if (!equipoRefId) {
            SetModalcharge(false)
            return
        }
        const equipoOriginal = await getDataList('Equipos', { _id: equipoRefId })
        const infoequipoCompleto = equipoOriginal?.data?.data[0]
        if (!infoequipoCompleto) {
            SetModalcharge(false)
            return
        }

        infoequipo.equipo = infoequipoCompleto
        const sedesDB = await getDataList('Sedes', {
                conditions: { cliente: infoequipoCompleto.cliente }
            });

        const sedesClientemap=sedesDB.data.data.map((sedes)=>({
            value:sedes._id,
            label:sedes.nameSede
          }))
        SetSedesClient(sedesClientemap)
        setEquipoeditar(infoequipoCompleto)

        // Preservar las ediciones ya hechas (sede, etc.) y solo garantizar
        // que `_id` del Equipos físico esté presente para el update.
        setInfoedit(prev => ({
            ...(prev || {}),
            _id: infoequipoCompleto?._id || infoequipo._id,
        }))
      }


      SetModalcharge(false)
      consultarOt()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[infoequipo?._id, infoequipo?.equipo?._id, infoequipo?.equipo])

  return (
    <>
        <Modalcarga
        estadoIn={modalcharge} 
        cambiarestadoIn={SetModalcharge}
        >
          <Spinner />
        </Modalcarga>

        {/* Modal de confirmación: corrección vs sustitución */}
        <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>Confirmar cambio</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Qué deseas hacer con los cambios registrados?</p>
                <p className='text-muted' style={{fontSize:'0.9em'}}>
                    <strong>Corregir datos:</strong> actualiza la información del equipo actual y sincroniza el registro en la OT.<br/>
                    <strong>Cambiar por otro equipo:</strong> reemplaza la referencia en la OT por un equipo existente con el serial ingresado.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowConfirm(false)}>
                    Cancelar
                </Button>
                <Button variant="warning" onClick={confirmarCambioEquipo}>
                    Cambiar por otro equipo
                </Button>
                <Button variant="primary" onClick={confirmarCorreccion}>
                    Corregir datos del mismo equipo
                </Button>
            </Modal.Footer>
        </Modal>

        
        {/* Modal de equipo existente cuando el serial ya está registrado */}
        
        
        <Modal show={showEqExistente} onHide={() => setShowEqExistente(false)} centered>
            <Modal.Header closeButton>
                <Modal.Title>Serial en uso por otro equipo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>El serial ingresado ya pertenece al siguiente equipo:</p>
                {eqExistente && (
                    <table className='table table-sm table-bordered'>
                        <tbody>
                            <tr><th>Ítem</th><td>{eqExistente.item?.nombre || eqExistente.item}</td></tr>
                            <tr><th>Marca</th><td>{eqExistente.marca}</td></tr>
                            <tr><th>Modelo</th><td>{eqExistente.modelo}</td></tr>
                            <tr><th>Serial</th><td>{eqExistente.serie}</td></tr>
                            <tr><th>Inventario</th><td>{eqExistente.inventario}</td></tr>
                            <tr><th>Sede</th><td>{eqExistente.sedeClient?.nameSede || eqExistente.sede}</td></tr>
                        </tbody>
                    </table>
                )}
                <p className='text-muted' style={{fontSize:'0.9em'}}>
                    Si deseas reemplazar el equipo actual en la OT por este, haz clic en "Usar este equipo".
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => setShowEqExistente(false)}>
                    Cancelar
                </Button>
                <Button variant="success" onClick={usarEquipoExistente}>
                    Usar este equipo
                </Button>
            </Modal.Footer>
        </Modal>

    {!modalcharge && equipo &&
       <form className='form_container' onSubmit={handleSubmit}>
            <div className="form-group w-100 px-4">
                <label className='form_group_label' htmlFor='marca'>Ítem:</label>
                <SelectConsult
                    dataDefault={equipo?.item.nombre}
                    handledata={handledata}
                    name='item'
                    collection={"Items"}
                    field={"nombre"}
                    baseFilter={{ 
                        "magnitud.consecutivo": `${equipo.item?.magnitud.consecutivo}`,
                        "type":"foreign",
                        "populate":[] }}
                    />
            </div>
            <div className='form_group'>
                <label className='form_group_label' htmlFor='marca'>Marca:</label>
                <input onChange={handledata} name='marca' className='titulo' type={'string'}  defaultValue={equipo?.marca} />
            </div>
            <div className='form_group '>
                <label className='form_group_label' htmlFor='modelo'>Modelo: </label>
                <input onChange={handledata} name='modelo' className='titulo' type={'string'}  defaultValue={equipo?.modelo} />
            </div>
            <div className='form_group '>
                <label className='form_group_label' htmlFor='serie'>Serie:</label>
                <input onChange={handledata} name='serie' className='titulo' type={'string'}  defaultValue={equipo?.serie} />
            </div>
            <div className='form_group '>
                <label className='form_group_label' htmlFor='inventario'>Inventario:</label>
                <input onChange={handledata} name='inventario' className='titulo' type={'string'}  defaultValue={equipo?.inventario} />
            </div>
            <div className='form_group '>
              <label className='form_group_label' htmlFor='sede'>Sede:</label>
              {/* Controlado por `values`: siempre refleja la sede seleccionada
                  (la del equipo cargado + la que el usuario elija). Antes el
                  Select era no controlado y, tras elegir, el toggle volvía a
                  mostrar el chip con el valor viejo porque react-dropdown-select
                  perdía su estado interno al desmontarse. */}
              <Select
                searchable
                onChange={selectSede}
                options={sedesClient || []}
                values={(() => {
                  const id =
                    infoedit?.sedeClient ||
                    equipo?.sedeClient?._id ||
                    equipo?.sedeClient;
                  const label =
                    infoedit?.sede ||
                    equipo?.sedeClient?.nameSede ||
                    equipo?.sede;
                  return id && label ? [{ value: id, label }] : [];
                })()}
                placeholder={'Seleccione una sede...'}
              />
            </div>
            <div className='form_group '>
                <label className='form_group_label' htmlFor='unicacion'>Ubicación:</label>
                <input onChange={handledata} name='ubicacion' className='titulo' type={'string'}  defaultValue={equipo?.ubicacion} />
            </div>
            <div className='form_group '>
                <label className='form_group_label' htmlFor='resolucion'>Resolución:</label>
                <input onChange={handledata} name='resolucion' className='titulo' type={'string'}  defaultValue={equipo?.resolucion} />
            </div>
            <div className='form_group'>
                <label className='form_group_label' htmlFor='puntos'>Puntos a calibrar:</label>
                <textarea  onChange={handledata} name='puntos' className='titulo' type={'string'}  defaultValue={equipo?.puntos} ></textarea>
            </div>
                <div className='form_group'>
                    <label className='form_group_label' htmlFor='observacion'>Observacion:</label>
                    <textarea  onChange={handledata} name='observacion' className='titulo' type={'string'}  defaultValue={infoequipo.observacion}></textarea>
                </div>
            <div className='form_group'> 
            <button type='submit'>Guardar cambios</button>
            </div>
        </form>
    }
    </>
  )
}
